import axiosInstance from "utils/axios-request";
import {gatewayUrl} from "config";

export const redirectToSetu = () => {
    const setuInterceptor = axiosInstance.interceptors.response.use((res) => {
        return res;
    }, (error) => {
    if (error.response && error.response.data && error.response.data.link) {
        window.location = error.response.data.link;
    } else {
        return Promise.reject(error);
    }});

    axiosInstance.request({
        baseURL: gatewayUrl,
        url: `/setu-gateway/direct-link`,
        method: "get",
    });

    axiosInstance.interceptors.response.eject(setuInterceptor);
};
